// Infobip error codes extracted from https://www.infobip.com/docs/essentials/api-essentials/response-status-and-error-codes

export const DIRECT_SND_ERROR_CODES = {
  NO_ERROR: {
    Description:
      'There is no error description provided. Mostly, it is returned for successful delivery or when the operator did not return any error code.',
    Permanent: false,
  },
  EC_UNKNOWN_SUBSCRIBER: {
    Description:
      'Typically, this indicates that the subscriber or recipient of the message is unknown or not recognized by the network. Verify the subscriber details by dialing the number. If correct, contact Support.',
    Permanent: true,
  },
  EC_UNKNOWN_BASE_STATION: {
    Description:
      'Suggests an error involving an unidentified or unrecognized base station, often in the context of network or communication systems. This could be due to a missing or inaccessible base station.',
    Permanent: false,
  },
  EC_UNIDENTIFIED_SUBSCRIBER: {
    Description:
      'This can occur for reasons such as an invalid or unregistered number, incomplete or incorrect subscriber information, or technical issues. Verify and correct subscriber information. If correct, contact Support.',
    Permanent: false,
  },
  EC_ABSENT_SUBSCRIBER_SM: {
    Description:
      "Indicates the destination numbers were unreachable, powered off, or in an area with limited coverage. Ensure the subscriber's device is turned on and has a stable network connection.",
    Permanent: false,
  },
  EC_UNKNOWN_EQUIPMENT: {
    Description:
      'The mobile device has not been recognized by EIR (Equipment Identity Register) during device verification on the MAP protocol level at the operator’s infrastructure.',
    Permanent: false,
  },
  EC_ROAMING_NOT_ALLOWED: {
    Description:
      'The subscriber is roaming in another country or operator’s infrastructure. Delivery is not guaranteed due to a lack of roaming agreements between operators.',
    Permanent: false,
  },
  EC_ILLEGAL_SUBSCRIBER: {
    Description:
      "Indicates the mobile station failed authentication, often due to the subscriber's number being blocklisted. Investigate and address the issue with the network operator, or contact Support.",
    Permanent: true,
  },
  EC_TELESERVICE_NOT_PROVISIONED: {
    Description:
      'The mobile subscription does not support the requested service (for example, SMS). Contact the service provider or network operator to activate the required teleservice.',
    Permanent: true,
  },
  EC_ILLEGAL_EQUIPMENT: {
    Description:
      'Indicates the IMEI check on the handset failed due to the IMEI being blocklisted or unauthorized. Use authorized equipment to resolve this issue.',
    Permanent: true,
  },
  EC_CALL_BARRED: {
    Description:
      "The operator suspended the subscriber’s service, usually for unpaid invoices. Check the subscriber's account status and ensure sufficient balance or contact the network operator to resolve.",
    Permanent: false,
  },
  EC_FACILITY_NOT_SUPPORTED: {
    Description:
      'The requested service is not supported by the handset or network. Verify the supported facilities and ensure compatibility. Restart the device and apply the latest software/firmware updates.',
    Permanent: false,
  },
  EC_ABSENT_SUBSCRIBER: {
    Description:
      "Indicates the destination numbers were unreachable, powered off, or in an area with limited coverage. Ensure the subscriber's device is turned on and has a stable network connection.",
    Permanent: false,
  },
  EC_SUBSCRIBER_BUSY_FOR_MT_SMS: {
    Description: 'Indicates that the subscriber is busy for MT SMS.',
    Permanent: false,
  },
  EC_SM_DELIVERY_FAILURE: {
    Description:
      'Indicates a failure in delivering an SMS to the recipient, possibly due to unavailability, memory capacity issues, or temporary communication issues. Verify details or contact Support.',
    Permanent: false,
  },
  EC_MESSAGE_WAITING_LIST_FULL: {
    Description: 'The message waiting list is full',
    Permanent: false,
  },
  EC_SYSTEM_FAILURE: {
    Description: 'Indicates a system failure',
    Permanent: false,
  },
  EC_DATA_MISSING: {
    Description: 'Indicates that some data is missing',
    Permanent: false,
  },
  EC_UNEXPECTED_DATA_VALUE: {
    Description: 'Indicates that an unexpected data value has been entered',
    Permanent: false,
  },
  EC_UNKNOWN_ERROR: {
    Description: 'Indicates an unknown error',
    Permanent: false,
  },
  EC_SM_DF_MEMORYCAPACITYEXCEEDED: {
    Description:
      "Indicates that the message inbox on the recipient's mobile phone is full, preventing new messages. Delete messages to clear space.",
    Permanent: false,
  },
  EC_SM_DF_EQUIPMENTPROTOCOLERROR: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_SM_DF_EQUIPMENTNOTSM_EQUIPPED: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_SM_DF_UNKNOWNSERVICECENTRE: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_SM_DF_SC_CONGESTION: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_SM_DF_INVALIDSME_ADDRESS: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_SM_DF_SUBSCRIBERNOTSC_SUBSCRIBER: {
    Description: 'There has been a mobile subscriber equipment error',
    Permanent: false,
  },
  EC_PROVIDER_GENERAL_ERROR: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_NO_RESPONSE: {
    Description:
      'The message was processed and forwarded to the operator, but no response was returned. The error may also apply to SS7 network level issues.',
    Permanent: false,
  },
  EC_SERVICE_COMPLETION_FAILURE: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_UNEXPECTED_RESPONSE_FROM_PEER: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_MISTYPED_PARAMETER: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_NOT_SUPPORTED_SERVICE: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_DUPLICATED_INVOKE_ID: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_CANNOT_RECEIVE_SC: {
    Description:
      'End users connected to this MVNO cannot receive short code messages. The mobile operator rejected the message as the end user is connected to their network through an MVNO. This restriction applies to short code messages.',
    Permanent: true,
  },
  EC_SC_BLOCKED_BY_END_USER: {
    Description:
      'The end user has asked their mobile operator to block messages sent from your short code. Additional messages must not be sent unless the end user opts in again.',
    Permanent: true,
  },
  EC_USER_OUT_OF_CREDIT: {
    Description:
      'The end user is out of prepaid credit and cannot receive the message. Retry sending every 24 hours for up to seven days.',
    Permanent: false,
  },
  EC_TEMPORARY_HANDSET_FAILURE: {
    Description: 'There is a temporary handset failure',
    Permanent: true,
  },
  EC_DEST_ADDRESS_UNABLE_TO_RECEIVE_SMS: {
    Description: 'The destination address is unable to receive SMS',
    Permanent: true,
  },
  EC_OR_APPCONTEXTNOTSUPPORTED: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_INVALIDDESTINATIONREFERENCE: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_INVALIDORIGINATINGREFERENCE: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_ENCAPSULATEDAC_NOTSUPPORTED: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_TRANSPORTPROTECTIONNOTADEQUATE: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_NOREASONGIVEN: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_POTENTIALVERSIONINCOMPATIBILITY: {
    Description:
      'General network protocol error caused by incompatible operator network protocol versions or parameters between network components.',
    Permanent: false,
  },
  EC_OR_REMOTENODENOTREACHABLE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_NOTRANSLATIONFORANADDRESSOFSUCHNATURE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_NOTRANSLATIONFORTHISSPECIFICADDRESS: {
    Description: 'No translation for this specific address',
    Permanent: false,
  },
  EC_NNR_SUBSYSTEMCONGESTION: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_SUBSYSTEMFAILURE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_UNEQUIPPEDUSER: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_MTPFAILURE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_NETWORKCONGESTION: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_UNQUALIFIED: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_ERRORINMESSAGETRANSPORTXUDT: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_ERRORINLOCALPROCESSINGXUDT: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_DESTINATIONCANNOTPERFORMREASSEMBLYXUDT: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_SCCPFAILURE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_HOPCOUNTERVIOLATION: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_SEGMENTATIONNOTSUPPORTED: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_NNR_SEGMENTATIONFAILURE: {
    Description:
      'The mobile subscriber was not reachable due to a network operator protocol error.',
    Permanent: false,
  },
  EC_UA_USERSPECIFICREASON: {
    Description: 'Message was aborted by a network peer due to a network protocol error.',
    Permanent: false,
  },
  EC_UA_USERRESOURCELIMITATION: {
    Description: 'Message was aborted by a network peer due to a network protocol error.',
    Permanent: false,
  },
  EC_UA_RESOURCEUNAVAILABLE: {
    Description: 'Message was aborted by a network peer due to a network protocol error.',
    Permanent: false,
  },
  EC_UA_APPLICATIONPROCEDURECANCELLATION: {
    Description: 'Message was aborted by a network peer due to a network protocol error.',
    Permanent: false,
  },
  EC_PA_PROVIDERMALFUNCTION: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_PA_SUPPORTINGDIALOGORTRANSACTIONREALEASED: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_PA_RESSOURCELIMITATION: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_PA_MAINTENANCEACTIVITY: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_PA_VERSIONINCOMPATIBILITY: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_PA_ABNORMALMAPDIALOG: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_NC_ABNORMALEVENTDETECTEDBYPEER: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_NC_RESPONSEREJECTEDBYPEER: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_NC_ABNORMALEVENTRECEIVEDFROMPEER: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_NC_MESSAGECANNOTBEDELIVEREDTOPEER: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_NC_PROVIDEROUTOFINVOKE: {
    Description: 'Message was aborted due to other network protocol errors.',
    Permanent: false,
  },
  EC_INVALID_REQUEST_TYPE: {
    Description: 'The request type was invalid.',
    Permanent: true,
  },
  EC_INVALID_DESTINATION_ADDRESS: {
    Description:
      "Invalid destination address. Possible reasons for receiving this error for the following mobile operators might be: **Any operator**: • The mobile number is not on the mobile operator's network. • The mobile number has been deactivated. **T-Mobile and MetroPCS**: • The phone number belongs to a prepaid user who does not have enough credit to receive a message. **T-Mobile**: • The end user is not provisioned to receive a message from all short codes (or from specific short codes) • The end user is on an MVNO connected through T-Mobile. • T-Mobile does not deliver messages from short codes to end users on MVNOs. **AT&T (US)**: • The phone number belongs to a prepaid user who does not have enough credit to receive a message. • The phone number is not provisioned for any messages. • The phone number could be blocked due to a spam complaint.",
    Permanent: false,
  },
  EC_INVALID_REQUEST_DESTINATION: {
    Description: 'Invalid request - destination address country code is not recognized.',
    Permanent: true,
  },
  EC_MSG_TEXT_TOO_LONG: {
    Description: 'Message text is too long.',
    Permanent: true,
  },
  EC_INVALID_SOURCE_ADDRESS: {
    Description:
      "Invalid source address value. The mobile operator rejected the message with an invalid MT source address error. Contact your account manager or reach out to Support to determine if the MT source address should be supported by the end user's mobile operator.",
    Permanent: true,
  },
  EC_ACCOUNT_ACCESS_DENIED: {
    Description: 'Account access has been denied.',
    Permanent: true,
  },
  EC_LIMIT_REACHED: {
    Description:
      'Carrier sending limit has been reached. The message was blocked by AT&T because the TPS (transactions per second) limit on your messaging campaign has been exceeded.',
    Permanent: false,
  },
  EC_QUOTA_REACHED: {
    Description:
      'Carrier daily quota reached. The message was blocked by T-Mobile because the daily volume limit for your brand has been exceeded. You cannot resend the message until the next day.',
    Permanent: false,
  },
  EC_CAMPAIGNID_NOT_PROVISIONED: {
    Description:
      'Program ID or campaign ID is not provisioned for this mobile operator or is not active.',
    Permanent: true,
  },
  EC_ACC_NOT_PROVISIONED_TO_SMS_DEMO_SC: {
    Description: 'The account is not provisioned to use the SMS demo short code.',
    Permanent: true,
  },
  EC_EXCEEDED_THE_TIME_LIMIT_OF_SMS_DEMO: {
    Description: 'Exceeded the time limit for using SMS demo.',
    Permanent: true,
  },
  EC_DEST_ADDRESS_NOT_IN_SMS_DEMO: {
    Description: 'The destination address is not in the safelist for SMS demo.',
    Permanent: true,
  },
  EC_EXCEEDED_THE_MAX_NUMBER: {
    Description: 'Exceeded the maximum number of demo requests.',
    Permanent: true,
  },
  EC_INVALID_GLOBAL_CAMPAIGN_ID: {
    Description: 'Invalid global campaign ID.',
    Permanent: true,
  },
  EC_ACC_HAS_NO_ADRESS_FOR_DESR: {
    Description: 'Account is not provisioned with an address that can reach the destination.',
    Permanent: true,
  },
  EC_INTERACTION_NOT_SUPPORTED: {
    Description: 'Interaction is not supported for the message destination.',
    Permanent: true,
  },
  EC_ACC_NOT_2_WAY: {
    Description: 'Account is not provisioned for global two-way SMS.',
    Permanent: true,
  },
  EC_CONTENT_BLOCKED: {
    Description:
      'Content blocked by user opt-out (MO: STOP). This code can be returned in a delivery receipt for an MT originating from a North American, SMS-enabled toll-free number or an SMS-enabled landline number. Messaging can resume to the end user if the end user opts back into your program.',
    Permanent: true,
  },
  EC_BLOCKED_BY_CAMPAIGN_BLACKLIST: {
    Description: 'Content blocked by campaign blocklist.',
    Permanent: true,
  },
  EC_REJECTED_SPAM_BY_OPERATOR: {
    Description: 'This message was identified as spam and cannot be delivered.',
    Permanent: true,
  },
  EC_SIGNALS_BLOCKED: {
    Description:
      'The message has been rejected due to an anti-fraud mechanism. It means that the risk score of the destination hit the defined threshold and the system blocked the message. In case of a false positive, you can use Signals API to add it to the trusted list.',
    Permanent: false,
  },
  EC_SIGNALS_HARD_LIMIT_REACHED: {
    Description: 'The daily system-defined limit for sent messages (UTC-based) has been reached.',
    Permanent: true,
  },
  EC_IMSI_BLACKLISTED: {
    Description: 'IMSI is blocklisted.',
    Permanent: true,
  },
  EC_BLACKLISTED_DESTINATIONADDRESS: {
    Description:
      'The destination number has been blocklisted either at the operators request or on your account through the web interface. Go to the web interface to remove the blocklist on your account or contact Support for more information.',
    Permanent: true,
  },
  EC_BLACKLISTED_SENDERADDRESS: {
    Description:
      "The sender number has been blocklisted either at the operator's request or on your account the web interface. Go to the web interface to remove the blocklist on your account or contact Support for more information.",
    Permanent: true,
  },
  EC_DEACTIVATED_LIST: {
    Description:
      'The phone number you provided is listed as deactivated, which means it is no longer active and cannot receive messages. If you included the mobileOperatorId in your request, you can perform an operator lookup to check if the number was ported to a new operator. If you did not include the mobileOperatorId, we have already performed the lookup and confirmed that the number is permanently deactivated. It is crucial to refrain from sending any further messages to this number. For more details, see the guidelines on handling deactivated phone numbers.',
    Permanent: true,
  },
  EC_INVALID_PDU_FORMAT: {
    Description: 'Invalid PDU format.',
    Permanent: true,
  },
  EC_MONTHLY_LIMIT_REACHED: {
    Description:
      'Your account monthly credit limit has been reached. For further financial assistance, contact your account manager or contact Support.',
    Permanent: true,
  },
  EC_MESSAGE_CANCELED: {
    Description:
      'The request was received, but has not been sent to the next instance within its validity period and has expired with the appropriate error code, or the same error code was reverted from the operator.',
    Permanent: true,
  },
  EC_VALIDITY_EXPIRED: {
    Description: 'The mobile operator could not contact the handset before the message expired.',
    Permanent: true,
  },
  EC_NOTSUBMITTEDTOSMPPCHANNEL: {
    Description:
      'Inbound SM cannot be transferred through SMPP due to the lack of SMPP connectivity.',
    Permanent: true,
  },
  EC_DESTINATION_FLOODING: {
    Description:
      'As per the flooding filter rule, you can send 6 messages with the same content to the same destination in one hour while or you can send up to 20 messages with different content to the same destination in a period of one hour. If there is a valid reason for the traffic to bypass the filter, your account manager can assist you with adjusting these limitations, or reach out to Support.',
    Permanent: true,
  },
  EC_DESTINATION_TXT_FLOODING: {
    Description:
      'Related to the REJECTED_FLOODING_FILTER status. The message is rejected due to the number of identical messages sent to a single number.',
    Permanent: true,
  },
  EC_10DLC_LIMIT_REACHED: {
    Description: 'Message was not delivered due to 10DLC operator limit.',
    Permanent: true,
  },
  VOICE_ANSWERED: {
    Description:
      'The voice call was successfully answered by the recipient. No further action is required.',
    Permanent: true,
  },
  VOICE_ANSWERED_MACHINE: {
    Description:
      'The voice call was answered by a machine or voicemail system. You may consider adjusting your communication strategy for machine-answered calls.',
    Permanent: true,
  },
  EC_VOICE_ERROR_TEMPORARILY_NOT_AVAILABLE: {
    Description:
      'Temporary unavailability of the voice service or recipient currently unavailable. Retry the operation later or contact Support for assistance.',
    Permanent: false,
  },
  EC_DECLINE: {
    Description:
      'The call was declined by the recipient or the end user rejected the call or is currently unavailable for the call. Consider alternative methods of communication or try reaching out again later.',
    Permanent: false,
  },
  EC_VOICE_USER_BUSY: {
    Description:
      "The recipient's phone line is busy. You can try calling again at a later time or explore other communication channels.",
    Permanent: true,
  },
  EC_VOICE_NO_ANSWER: {
    Description:
      'The recipient did not answer the call. You may try calling again later or choose an alternative communication method.',
    Permanent: true,
  },
  EC_VOICE_ERROR_DOWNLOADING_FILE: {
    Description:
      "An error occurred while downloading the audio file for playback. Verify the file's accessibility and format. If the issue persists, contact Support for further assistance.",
    Permanent: true,
  },
  EC_VOICE_ERROR_UNSUPPORTED_AUDIO_FORMAT: {
    Description:
      'The audio format is not supported. Check the audio format requirements, use supported types, and ensure compatibility with the voice service.',
    Permanent: true,
  },
  EC_VOICE_ERROR_BAD_REQUEST: {
    Description:
      'The voice call request was malformed or contained invalid parameters. Review the request or ensure it is properly formatted and check the API documentation for the correct request structure.',
    Permanent: false,
  },
  EC_VOICE_ERROR_FORBIDDEN: {
    Description:
      'The voice call request was rejected by the operator. Contact Support for further assistance.',
    Permanent: false,
  },
  EC_VOICE_ERROR_DESTINATION_NOT_FOUND: {
    Description:
      "The destination for the voice call was not found or is invalid. Double-check the recipient's phone number or destination details.",
    Permanent: false,
  },
  EC_VOICE_ERROR_PROXY_AUTHENTICATION_REQUIRED: {
    Description:
      'Proxy authentication is required to establish the voice call. Contact Support for further assistance.',
    Permanent: false,
  },
  EC_VOICE_ERROR_REQUEST_TIMEOUT: {
    Description:
      'The voice call request timed out before a response was received or the end user could not be found in time during the call. Contact Support for further assistance.',
    Permanent: false,
  },
  EC_VOICE_ERROR_GONE: {
    Description:
      "The requested voice call resource is no longer available. Ensure the recipient's phone number is valid and accessible or contact Support for further assistance.",
    Permanent: false,
  },
  EC_VOICE_ERROR_REQUEST_ENTITY_TOO_LARGE: {
    Description:
      'The voice call request entity (for example, audio file) is too large. Reduce the size of the request entity and try again.',
    Permanent: false,
  },
  EC_VOICE_ERROR_REQUEST_URI_TOO_LONG: {
    Description:
      'The server is refusing to process the request because the Request-URI is longer than the server is willing to interpret (destination too long).',
    Permanent: false,
  },
  EC_VOICE_UNSUPPORTED_MEDIA_TYPE: {
    Description:
      'The media type used in the voice call is not supported. Ensure you are using a compatible media type for the voice call.',
    Permanent: false,
  },
  EC_VOICE_ERROR_CALL_DOES_NOT_EXIST: {
    Description:
      'The voice call record/transaction does not exist. Contact Support for further assistance.',
    Permanent: false,
  },
  EC_VOICE_ERROR_ADDRESS_INCOMPLETE: {
    Description:
      'The address (for example, destination number) provided for the voice call is incomplete or invalid. Make sure the address is correctly formatted.',
    Permanent: false,
  },
  EC_VOICE_ERROR_REQUEST_TERMINATED: {
    Description:
      'The voice call request was terminated with a cancel button or the end user refused to receive a voice call.',
    Permanent: false,
  },
  EC_VOICE_ERROR_NOT_ACCEPTABLE_HERE: {
    Description:
      'The voice call request is not acceptable on the operator’s end. Contact Support for further assistance.',
    Permanent: false,
  },
  EC_VOICE_ERROR_REQUEST_PENDING: {
    Description:
      'The voice call request is pending and waiting for further processing. Wait for the request to be processed or check the status later.',
    Permanent: false,
  },
  EC_NOT_IMPLEMENTED: {
    Description:
      'The requested voice call feature is not implemented or supported. Contact Support for further assistance.',
    Permanent: true,
  },
  EC_SERVICE_UNAVAILABLE: {
    Description:
      'The voice call service is temporarily unavailable. Retry the request later or contact Support for further information.',
    Permanent: true,
  },
  NORMAL_HANGUP: {
    Description: 'The call ended due to a hangup initiated by the caller, callee, or API.',
    Permanent: true,
  },
  ANSWERED_ELSEWHERE: {
    Description:
      'The call was answered on another device or platform. Verify the call status on the intended device or investigate further if needed.',
    Permanent: true,
  },
  MACHINE_DETECTED: {
    Description:
      'The voice call was answered by a machine or voicemail system. You may consider adjusting your communication strategy for machine-answered calls.',
    Permanent: true,
  },
  HUMAN_DETECTED: {
    Description:
      "A human answered the call. You can take appropriate action based on the call's purpose.",
    Permanent: true,
  },
  MAX_DURATION_REACHED: {
    Description:
      'The call reached the maximum allowed duration. If needed, initiate a new call or adjust the call duration settings and contact Support for further assistance.',
    Permanent: true,
  },
  DEVICE_FORBIDDEN: {
    Description:
      'The device (camera and/or microphone) used for the call is not allowed or blocked. Check device permissions or restrictions and take appropriate action.',
    Permanent: true,
  },
  DEVICE_NOT_FOUND: {
    Description:
      'The device (camera and/or microphone) for the call could not be found or is unavailable. Ensure the device is accessible and try again.',
    Permanent: true,
  },
  DEVICE_UNAVAILABLE: {
    Description: 'The device (camera and/or microphone) for the call is currently unavailable.',
    Permanent: true,
  },
  MEDIA_ERROR: {
    Description:
      'An error occurred with the media during the call (for example, an audio issue). Check the media settings and equipment, and troubleshoot as necessary.',
    Permanent: true,
  },
  NO_ANSWER: {
    Description:
      'The call was successfully delivered to the end user device; however, it was not answered by the end user.',
    Permanent: true,
  },
  BUSY: {
    Description:
      "The call has been successfully delivered to the end user's device, but the end user's device indicates that they are currently busy and unable to answer the incoming call.",
    Permanent: true,
  },
  CANCELLED: {
    Description:
      'The call was canceled at the origination end before it could be successfully routed to the end user.',
    Permanent: true,
  },
  REJECTED: {
    Description: 'The call was rejected/declined by the end user at the receiving end.',
    Permanent: true,
  },
  TEMPORARILY_UNAVAILABLE: {
    Description:
      "The end user was unavailable to receive the call at the moment. The operator attempted to connect the call but encountered an issue with the end user's connection or availability, resulting in the call not being successfully connected. It is advisable to verify if the phone number provided is valid and reachable to ensure effective communication in the future.",
    Permanent: true,
  },
  FORBIDDEN: {
    Description: 'The received request was rejected. Contact Support for further assistance.',
    Permanent: true,
  },
  INSUFFICIENT_FUNDS: {
    Description:
      'The account you are using does not have sufficient credits or funds available to initiate the phone call you are attempting to make. In order to proceed with the call, you will need to ensure that there are enough credits or funds in your account.',
    Permanent: true,
  },
  UNAUTHENTICATED: {
    Description:
      "The caller's credentials or access rights are invalid or insufficient to initiate the call. To resolve this, ensure that the caller provides valid authentication credentials or obtains proper authorization for making the call.",
    Permanent: true,
  },
  DESTINATION_NOT_FOUND: {
    Description:
      'The server was unable to locate the destination number you dialed. This could be due to an incorrect country prefix or an invalid number format. To resolve this issue, double-check the country prefix and ensure that the number you dialed is accurate and in the correct format.',
    Permanent: true,
  },
  DESTINATION_UNAVAILABLE: {
    Description:
      'The destination number you attempted to call is currently unavailable to receive incoming calls. To address this situation, it is recommended to verify if the number you dialed is valid and reachable.',
    Permanent: true,
  },
  INVALID_DESTINATION: {
    Description:
      'The server was unable to locate the destination number you dialed. This could be due to an incorrect country prefix or an invalid number format. To resolve this issue, double-check the country prefix and ensure that the number you dialed is accurate and in the correct format.',
    Permanent: true,
  },
  INVALID_REQUEST: {
    Description:
      'The call request is invalid or malformed. Review the request parameters and structure, and make necessary adjustments.',
    Permanent: true,
  },
  REQUEST_TIMEOUT: {
    Description:
      'The call request timed out without a response. For more specific details and assistance, contact Support.',
    Permanent: true,
  },
  NETWORK_ERROR: {
    Description:
      'An error occurred in the network during the call. Check the network connection and contact Support for further investigation.',
    Permanent: true,
  },
  SERVICE_UNAVAILABLE: {
    Description: 'The call service is temporarily unavailable. Contact Support for assistance.',
    Permanent: true,
  },
  UNKNOWN: {
    Description:
      'An unknown error occurred during the call. Contact Support for further investigation and assistance.',
    Permanent: true,
  },
  FEATURE_UNAVAILABLE: {
    Description:
      'The requested call feature is not available or supported. Consider alternative features or methods for communication or contact Support for assistance.',
    Permanent: true,
  },
  CONGESTION: {
    Description:
      'The call could not be completed due to network congestion or overload. Contact Support for further investigation and assistance.',
    Permanent: true,
  },
  UNAUTHORIZED: {
    Description:
      'The destination number you attempted to call has not authorized incoming calls. To resolve this situation, obtain authorization from the callee or their service provider.',
    Permanent: true,
  },
  URL_NOT_FOUND: {
    Description:
      'The requested URL for the call was not found. Verify the URL and make necessary corrections.',
    Permanent: true,
  },
  URL_UNREACHABLE: {
    Description:
      'The requested URL for the call is unreachable. Check the network connectivity and URL accessibility.',
    Permanent: true,
  },
  INVALID_RESPONSE: {
    Description:
      'The response received during the call is invalid or unexpected. Contact Support for assistance.',
    Permanent: true,
  },
  EC_DEVICE_APP_UNINSTALL: {
    Description: 'User has uninstalled the application on device or device cloud token expired.',
    Permanent: true,
  },
  EC_FCM_MISMATCH_SENDER_ID: {
    Description:
      "FCM responded with MismatchSenderId in response error field. Sender ID is a unique numerical value created when you create your Firebase project, available in the **Cloud Messaging** tab of the Firebase console's **Settings** panel. The sender ID is used to identify each app server that can send messages to the client app. Check your application build configuration.",
    Permanent: true,
  },
  EC_NO_APPLICATION_FOUND: {
    Description:
      'Application with provided ApplicationCode for sending push messages is not found. Check your message target parameters.',
    Permanent: true,
  },
  EC_NO_REGISTRATION_ID_FOUND: {
    Description: 'Registration with provided PushRegistrationId does not exist or has expired.',
    Permanent: true,
  },
  EC_SYS_ERROR_FROM_CLOUD: {
    Description:
      'Failed to send push notification. Cloud (FCM or APNS) responded with error while processing the request.',
    Permanent: true,
  },
  EC_INVALID_FCM_AUTH_DATA: {
    Description:
      'Invalid cloud authentication data (Server Key). FCM responded with status **401 (Unauthorized)**. Check your Application configuration for Android on the web interface.',
    Permanent: true,
  },
  EC_INVALID_APNS_CERT: {
    Description:
      'Invalid certificate for APNS. Check your Application configuration for iOS on the web interface.',
    Permanent: true,
  },
  EC_APPLICATION_CLOUD_TYPE_DISABLED: {
    Description:
      'Cloud type was disabled by client for the application. Request is targeted to registration with cloud type that was disabled by the client. Check your Application configuration on the web interface.',
    Permanent: true,
  },
  EC_PUSH_INTERNAL_REQUEST_ERROR: {
    Description:
      'Internal error. Try again later and, if the problem persists, contact Support for further assistance.',
    Permanent: true,
  },
  EC_INVALID_PUSH_PAYLOAD: {
    Description: 'Invalid push payload data. Contact Support for further assistance.',
    Permanent: true,
  },
  EC_PUSH_INTERNAL_GW_ERROR: {
    Description:
      'Internal error. Try again later and if the problem persists, contact Support for further assistance.',
    Permanent: true,
  },
  EC_PUSH_CLOUD_TEMP_UNAVAILABLE: {
    Description:
      'Push Cloud (FCM or APNS) is temporarily unavailable. Message is pending in retry.',
    Permanent: true,
  },
  EC_REGISTRATION_ID_DISABLED: {
    Description:
      'Push notifications cannot be delivered because the recipient’s device is not able to receive them. Possible causes from the recipient’s side: - Manually disabled notifications - App was uninstalled Possible causes from your side: - The installation was disabled for this recipient’s profile in People - The installation was disabled in the app code If cause was from your side, you can resolve the issue by enabling the installation again for this recipient’s profile in People or refer to the SDK documentation for mobile messaging.',
    Permanent: true,
  },
  EC_MMS_GENERAL_ERROR: {
    Description: 'Indicates an MMS provider general error occurred.',
    Permanent: false,
  },
  EC_SYSTEM_ERROR: {
    Description: 'Indicates a system error occurred.',
    Permanent: true,
  },
  EC_MSISDN_NOT_REGISTERED: {
    Description: 'The MSISDN is not registered by the operator.',
    Permanent: true,
  },
  EC_DEFERRED: {
    Description:
      "The message is deferred. The end user's handset has retrieved the MMS header, but not the full message.",
    Permanent: false,
  },
  EC_MMS_FORWARDED: {
    Description: 'The end user has forwarded the MMS to another address without retrieving it.',
    Permanent: true,
  },
  EC_CONTENT_CANNOT_BE_DOWNLOADED_ON_HANDSET: {
    Description: 'The content cannot be downloaded on the handset.',
    Permanent: true,
  },
  EC_PROVIDER_DELIVERY_ERROR: {
    Description: 'Indicates an MMS provider error occurred during the delivery.',
    Permanent: true,
  },
  EC_RECIPIENT_NOT_FOUND: {
    Description: 'The mobile operator could not find the recipient on the mobile.',
    Permanent: true,
  },
  EC_SOURCE_ADDRESS_NOT_REGISTERED: {
    Description: 'The source address not provisioned with the operator.',
    Permanent: true,
  },
  EC_RECIPIENT_BLOCKED_BY_OPERATOR: {
    Description: 'The recipient blocked by receiving MMS by the operator.',
    Permanent: true,
  },
  EC_DRM_NOT_SUPPORTED: {
    Description: 'DRM is not supported.',
    Permanent: true,
  },
  EC_MMS_CONTENT_BLOCKED_BY_OPERATOR: {
    Description: 'MMS content blocked or is unsupported by the operator.',
    Permanent: true,
  },
  EC_MMS_INVALID_SUBJECT: {
    Description: 'The MMS subject in the request is invalid.',
    Permanent: true,
  },
  EC_MMS_SC_BLOCKED_BY_END_USER: {
    Description: 'The end user has blocked traffic from this specific SC.',
    Permanent: true,
  },
  EC_UNKNOWN_CARRIER: {
    Description: 'Unable to determine the mobile operator.',
    Permanent: true,
  },
  EC_RECIPIENT_DEACTIVATED: {
    Description: 'The recipient is deactivated.',
    Permanent: true,
  },
  EC_RECIPIENT_SUSPENDED: {
    Description: 'The recipient is suspended from the service.',
    Permanent: true,
  },
  EC_HANDSET_DOES_NOT_SUPPORT_MMS: {
    Description: 'MMS is not supported on the handset.',
    Permanent: true,
  },
  EC_CAMPAIGN_BLOCKED_BY_OPERATOR: {
    Description: 'The campaign is blocked by the mobile operator.',
    Permanent: true,
  },
  EC_CAMPAIGN_INFO_NOT_PROVISIONED: {
    Description: 'Campaign information is not provisioned for this mobile operator.',
    Permanent: true,
  },
  EC_URL_ATTACHMENT_TOO_LARGE: {
    Description: 'The MMS cannot be retrieved because the URL attachment is too large.',
    Permanent: true,
  },
  EC_FAILED_TO_ROUTE_MESSAGE: {
    Description: 'The MMS message could not be routed.',
    Permanent: true,
  },
  EC_REMOTE_CONTENT_FAILURE: {
    Description: 'The remote content could not be retrieved.',
    Permanent: true,
  },
  EC_REMOTE_CONTENT_INTERNAL_FAILURE: {
    Description: 'An internal error occurred while trying to fetch the remote content.',
    Permanent: true,
  },
  EC_TOO_BIG_CONTENT: {
    Description: 'The message was rejected because the submitted content exceeds operator limits.',
    Permanent: true,
  },
  EC_INVALID_MSG_TYPE: {
    Description: 'The MMS message type is invalid.',
    Permanent: true,
  },
  EC_MMS_INVALID_DESTINATION_ADDRESS: {
    Description: 'The MMS destination address is invalid.',
    Permanent: true,
  },
  EC_MMS_INVALID_SOURCE_ADDRESS: {
    Description: 'The MMS source address is invalid.',
    Permanent: true,
  },
  EC_INVALID_SUBJECT: {
    Description: 'The MMS subject parameter is invalid.',
    Permanent: true,
  },
  EC_SPAM_DETECTED: {
    Description:
      'The content you are trying to send was detected as possible spam by the platform. Review the Email deliverability section and adjust your content accordingly before retry.',
    Permanent: true,
  },
  EC_UNSUBSCRIBED_EMAIL_ADDRESS: {
    Description:
      'The recipient opted out of receiving updates from this specific address. If removal is desired, complete the request by going to the Do not contact option in the web interface.',
    Permanent: true,
  },
  EC_SENDER_DOMAIN_BOUNCE_BLOCKED: {
    Description:
      'Your domain has been blocked due to a high bounce rate to protect IPs and its reputation. The domain unblocking procedure is automated and will happen after a 24-hour cooling-off period. To prevent this from occurring in the future, check the reports and clean up your recipient database from inactive addresses. Review the Email validation section to help you with the procedure.',
    Permanent: true,
  },
  EC_REQUEST_INVALID: {
    Description:
      'The submitted request is not valid. Ensure that the data and request parameters are accurate and in the right format.',
    Permanent: true,
  },
  EC_EMAIL_TEMPLATE_NOT_FOUND: {
    Description:
      'The email template from the request could not be found. Make sure that the template ID is correct before retry.',
    Permanent: true,
  },
  EC_EMAIL_PLACEHOLDERS_ERROR: {
    Description:
      'Error with placeholders in the content. Check the placeholders to confirm there are no issues or typos in them and retry.',
    Permanent: true,
  },
  EC_BLOCKED_SUSPICIOUS_ACTIVITY: {
    Description:
      'Your domain has been blocked due to suspicious activity. Should you require any additional information regarding this matter, contact Support or your account manager.',
    Permanent: true,
  },
  EC_EMAIL_TOO_MANY_URLS: {
    Description:
      'Maximum amount of URLs with Tracking enabled is 150. Lower the amount of URLs or turn off the Tracking features before retry.',
    Permanent: true,
  },
  EC_EMAIL_INVALID_TRACKING_PARAMS: {
    Description: 'Tracking parameters in the email are not valid. Review them and then retry.',
    Permanent: true,
  },
  EC_EMAIL_LANDING_PAGE_PLACEHOLDERS_SIZE_EXCEEDED: {
    Description:
      'Size of the placeholders on the landing page limit is 256 characters. Adjust (decrease) the landing page placeholder size accordingly and retry.',
    Permanent: true,
  },
  EC_EMAIL_INVALID_HEADERS: {
    Description:
      'The headers of the email are invalid or improperly formatted. Check the headers and ensure they meet the required format.',
    Permanent: true,
  },
  EC_SENDER_ADDRESS_INVALID: {
    Description:
      'The email sender is invalid or unauthorized to send emails. To resolve the issue, check the sender domain for spelling mistakes and ensure that the domain is verified and properly configured.',
    Permanent: true,
  },
  EC_EMAIL_INVALID_LANDING_PAGE: {
    Description:
      "The specified landing page is invalid or inaccessible. Confirm the landing page's URL and availability and retry.",
    Permanent: true,
  },
  EC_INVALID_PRESERVED_CC_OR_BCC_RECIPIENT: {
    Description:
      'Invalid preserved recipient in CC or BCC. Check the recipient list and ensure that all preserved recipients are valid and the limit is not reached.',
    Permanent: true,
  },
  EC_INVALID_CC_BCC_EMAIL_ADDRESS: {
    Description:
      'The request contains invalid addresses in the CC and/or BCC. Ensure that the addresses are correctly formatted by checking them.',
    Permanent: true,
  },
  EC_SUPPRESSED_BOUNCE: {
    Description:
      "A bounce SMTP response from the recipient's mailbox provider earlier has resulted in the recipient address being suppressed.",
    Permanent: true,
  },
  EC_SUPPRESSED_SPAM_COMPLAINT: {
    Description:
      "Due to the recipient reporting previous content sent from the same domain as spam, the recipient's address has been suppressed. _Note that this error code will be deployed at a later stage. For the time being, spam complaints will be marked with **EC 6034**._",
    Permanent: true,
  },
  EC_SENDER_DOMAIN_UNVERIFIED: {
    Description:
      'Domain does not currently have all required DNS records set up correctly. Check your DNS configuration. See Verify your sender domain.',
    Permanent: true,
  },
  EC_EMAIL_CONTENT_EXPIRED: {
    Description:
      'The content in a template expired due to the lack of regular usage. To resolve the issue, check the content and re-upload it. If the issue persists, contact Support.',
    Permanent: true,
  },
  EC_EMAIL_TEMPLATE_LANGUAGE_ERROR: {
    Description:
      'Error in template language in your content. See Template language for more details. If the problem persists, contact Support.',
    Permanent: true,
  },
  EC_EMAIL_TEMPLATE_EXPIRED: {
    Description:
      'The template validity period expired. Either update a template to prolong the validity, or copy it and update the template ID before retry.',
    Permanent: true,
  },
  EC_EMAIL_TEMPLATE_NOT_SAVED: {
    Description:
      'The template was not saved. Make sure the requested template is correctly stored on the web interface before retry.',
    Permanent: true,
  },
  EC_SENDER_WARMUP: {
    Description: 'The sender domain has reached its reputation warmup limit for today.',
    Permanent: false,
  },
  EC_WARMUP: {
    Description: 'The sender has reached its reputation warmup limit for today.',
    Permanent: false,
  },
  EC_RECIPIENT_DOMAIN_TYPO: {
    Description: 'Recipient domain is blocked as it is listed on the Infobip internal blocklist.',
    Permanent: true,
  },
  EC_ACCESS_DENIED_BY_MAILBOX_PROVIDER: {
    Description: 'The mailbox provider has denied access for the sender.',
    Permanent: false,
  },
  EC_SINGLE_SENDER_NOT_VERIFIED: {
    Description:
      'Single sender not verified. Verify your sender address before retrying the traffic.',
    Permanent: true,
  },
  EC_SINGLE_SENDER_TRAFFIC_EXCEEDED: {
    Description:
      'Your account has reached the limit of 100 emails sent from registered Single Sender address(es). To continue sending emails through Infobip, add your domain to your account. For more information, see Register a new domain.',
    Permanent: true,
  },
  EC_NO_IP_POOL_ASSIGNED: {
    Description: 'The registered sending domain does not have an IP pool assigned.',
    Permanent: false,
  },
  EC_SAFETY_RATE_LIMIT: {
    Description:
      'The sending IP/domain is rate limited by the platform to protect the IP/domain reputation, as rejections were noticed from the specific mailbox provider. This usually relates to the lack of warmup or negative reactions by traffic recipients. To resolve the issue, slow down the traffic towards the specific provider to increase your reputation gradually. For more information, see IP and domain warmup.',
    Permanent: false,
  },
  EC_MAILBOX_PROVIDER_RATE_LIMIT: {
    Description: 'The sending IP or domain is limited by the mailbox provider.',
    Permanent: false,
  },
  EC_INVALID_EMAIL_ADDRESS: {
    Description:
      "The recipient's email address provided is either invalid, inactive, or disabled. Check for possible typos and validate the address before the retry. Review the Email validation section to help you with the procedure.",
    Permanent: true,
  },
  EC_MAILBOX_TEMPORARY_UNAVAILABLE: {
    Description:
      "The recipient's mailbox is temporarily unavailable. Retry the email in a few hours and contact Support if you continue to encounter the same response for the additional checks.",
    Permanent: false,
  },
  EC_MAILBOX_PERMANENTLY_UNAVAILABLE: {
    Description:
      "The recipient's mailbox provider (domain) might be permanently unavailable. Contact the recipient and attend to the situation before retry.",
    Permanent: true,
  },
  EC_RECIPIENT_INBOX_FULL: {
    Description:
      "The recipient's mailbox storage limit has been reached and they cannot receive additional emails. Contact the recipient and resolve this situation by clearing some data.",
    Permanent: false,
  },
  EC_SOFT_BOUNCE: {
    Description:
      'Response indicates a temporary delivery error. Retry sending and if the same response is returned, contact the recipient to attend to the situation.',
    Permanent: false,
  },
  EC_HARD_BOUNCE: {
    Description:
      'Response is indicating a permanent error related to the delivery. Contact the recipient to confirm and solve the situation.',
    Permanent: true,
  },
  EC_SENDER_IP_BLACKLISTED: {
    Description:
      'The IP address assigned to your domain has been blocklisted. See Email deliverability and request the de-listing on the relevant blocklist.',
    Permanent: false,
  },
  EC_RECIPIENT_DOMAIN_MX_NOT_FOUND: {
    Description:
      'The domain to which this address belongs is possibly unavailable or does not exist due to the MX not being found or being unavailable. Check the address for any typos and validate the address.',
    Permanent: true,
  },
  EC_SPAM_REVERTED: {
    Description:
      'The content in the email was flagged as spam by the mailbox provider. See Email deliverability and adjust your content accordingly before retry.',
    Permanent: true,
  },
  EC_SUSPICIOUS_CONTENT: {
    Description:
      'Mailbox provider decided to deny your traffic due to the suspicious content. Ensure that you are following content best practices before retrying the traffic. If the error persists, contact the mailbox provider.',
    Permanent: true,
  },
  EC_SUSPICIOUS_SENDER: {
    Description:
      "Recipient mailbox provider denied your messages due to very low reputation of your domain or IPs. This usually happens due to different sending best practices not being followed. Ensure that you respect general and mailbox provider's best practices when sending traffic. If the error repeats, contact the mailbox provider to resolve the situation.",
    Permanent: true,
  },
  EC_RECIPIENT_DOMAIN_POLICY_ERROR: {
    Description:
      "Mailbox provider blocked your message as it does not meet their email policy requirements for your organization or for the recipient's organization. Follow the best practices and if the error repeats, contact the recipient for additional details and possible solution.",
    Permanent: true,
  },
  EC_UNSOLICITED_RECIPIENT: {
    Description:
      'The recipient mailbox provider (domain) has detected that this message is likely to be an unsolicited email; therefore, it was blocked. Ensure that your recipients are subscribed and interested in the traffic before retry.',
    Permanent: false,
  },
  EC_DOMAIN_CONFIGURATION_ERROR: {
    Description:
      'Your domain might be missing valid DKIM or SPF, so your traffic has been denied by the recipient mailbox provider. Ensure that your DNS records are valid before retry.',
    Permanent: true,
  },
  EC_DMARC_POLICY_ISSUE: {
    Description:
      "Recipient mailbox provider denied your domain's DMARC policy. Ensure that the policy is valid before retry and if the error repeats, contact the recipient mailbox provider for further instructions.",
    Permanent: true,
  },
  EC_SENDER_DOMAIN_BLACKLISTED: {
    Description:
      'Your domain has been blocklisted by the recipient mailbox. See Email deliverability and request the de-listing on the relevant blocklist.',
    Permanent: true,
  },
  EC_INTERNAL_SYSTEM_ERROR: {
    Description:
      'Something went wrong on the Infobip end. Retry the traffic and contact Support if the same error is returned.',
    Permanent: false,
  },
  EC_UNKNOWN_APPLICATION: {
    Description:
      'Indicates that the requested application is unknown or not recognized. Resolution steps involve verifying the application details, ensuring proper configuration, and contacting the appropriate support channels for assistance.',
    Permanent: true,
  },
  EC_UNKNOWN_USER: {
    Description:
      "Signifies that the user is unknown or not registered. In the context of RCS, this means the user cannot be reached through RCS because: • Their device does not support RCS or RCS is disabled. • Their mobile network does not support RCS for the agent (either the agent is not launched there or RCS traffic is not enabled). • An unlaunched agent is requesting capabilities for a user who is not a registered tester. To resolve this error, verify the user's details or ensure that the MSISDN is correct and belongs to an active user. If the user’s device or network does not support RCS, use the fallback communication channels. Verify the Agent is launced with the Provider/Carrier to which the MSISDN belongs to.",
    Permanent: true,
  },
  EC_BLOCKED_USER: {
    Description:
      'Indicates that the user has been blocked or restricted from accessing the messages. In RCS, this occurs when the user has opted out of further communication from the agent. Resolution steps involve investigating the reason for the user block, reviewing any violation or restriction policies, and taking appropriate actions such as unblocking or contacting Support for further assistance.',
    Permanent: true,
  },
  EC_UNAUTHORIZED_ACCESS: {
    Description:
      'Denotes unauthorized access or unrecognized service access credentials. To resolve this error, investigate the unauthorized access attempt, ensure proper authentication/credentials, and contact Support for further assistance.',
    Permanent: true,
  },
  EC_FORBIDDEN_ACCESS: {
    Description:
      "Indicates that access to the requested resource or service is forbidden. In RCS, this may occur when: • An unlaunched agent attempts to send a message, event, or capability callback to a non-tester. • The carrier does not support RCS or the carrier itself is not supported. Resolution steps involve verifying the user's access rights and permissions, ensuring the application is allowed to send messages, and verifying that it is published or approved by the provider.",
    Permanent: true,
  },
  EC_BAD_REQUEST: {
    Description:
      'The server cannot process the request due to invalid syntax or parameters. In RCS, this typically occurs when: • The message contains unsupported content. • The message includes features or settings that the recipient’s device does not support. Verify the request data and ensure that it follows the required format or check the API documentation for the correct request structure or contact Support for additional guidance.',
    Permanent: true,
  },
  EC_ILLEGAL_TRAFFIC_TYPE: {
    Description:
      'Indicates that the content of the submitted message does not align with the registered traffic type of the sender. This could be due to the use of incompatible media elements or not understanding any restrictions or guidelines related to traffic types. For more specific details and assistance, contact Support.',
    Permanent: true,
  },
  EC_INVALID_TEMPLATE_ARGS: {
    Description:
      'Denotes invalid or missing parameters in a message template. To resolve this error, review the template structure, ensure that all required parameters are provided, and correct any invalid or missing parameters.',
    Permanent: true,
  },
  EC_INVALID_TEMPLATE: {
    Description:
      "Signifies an invalid or incorrect message template. In RCS, it's used on connections that have template management. Resolution steps involve reviewing the template and making the necessary modifications or corrections.",
    Permanent: true,
  },
  EC_NO_SESSION: {
    Description:
      'Indicates that the session has not been initiated or has expired. To resolve this error, establish a valid session by authenticating the user or application, ensuring a new session, or extending the existing session.',
    Permanent: true,
  },
  EC_ACCOUNT_ISSUE: {
    Description:
      "Signifies an issue or problem related to the user's account. Resolution steps involve investigating the account-related problem and contacting Support for further assistance.",
    Permanent: true,
  },
  EC_DEPLOYMENT_CONFIGURATION_ERROR: {
    Description:
      'Denotes an error or issue with the deployment or configuration of the system or service. To resolve this error, contact Support for further assistance.',
    Permanent: false,
  },
  EC_MEDIA_HOSTING_ERROR: {
    Description:
      'Indicates an error or problem related to media hosting or storage. Resolution steps involve verifying the media hosting setup, ensuring proper connectivity, and resolving any hosting-related issues.',
    Permanent: false,
  },
  EC_MEDIA_UPLOAD_ERROR: {
    Description:
      'Signifies an error or problem encountered during media upload. To resolve this error, check for any network or connectivity issues, and ensure that the media file meets the specified requirements.',
    Permanent: false,
  },
  EC_MEDIA_METADATA_ERROR: {
    Description:
      'Denotes an error or issue with the metadata associated with media files. Resolution steps involve reviewing the metadata information, ensuring content type and size, and resolving any metadata-related problems.',
    Permanent: true,
  },
  EC_SPAM_RATE: {
    Description:
      'Message failed because there are restrictions related to the sender quality rating on how many messages can be sent from this sender to unique end users during the period defined by the provider.',
    Permanent: true,
  },
  EC_TOO_MANY_REQUESTS: {
    Description:
      'Signifies that the number of requests from the application has exceeded the allowed limit. In RCS, this occurs when tester request quotas are exceeded, such as sending more than 20 tester requests in a single day or surpassing the total maximum of 200 tester requests. To resolve this error, reduce the frequency or number of requests, adhere to rate limits, and consider optimizing the request flow if necessary.',
    Permanent: false,
  },
  EC_INTERNAL_BAD_MAPPING: {
    Description:
      'Denotes an internal error related to mapping or data structures within the system. In RCS, this occurs when a message is rejected due to an invalid request, such as using a disallowed image format or incorrectly applying message parameters. Resolution steps involve investigating the mapping issue, reviewing and resolving any inconsistencies or errors in the mapping process, and contacting Support for further assistance.',
    Permanent: true,
  },
  EC_PROVIDER_BILLING_ERROR: {
    Description:
      'Indicates an error or problem with the billing process or integration with the provider. To resolve this error, review the billing setup, ensure proper integration and configuration with the provider, and address any billing-related issues or errors.',
    Permanent: true,
  },
  EC_DEVICE_REPRODUCTION_ERROR: {
    Description:
      'Signifies an error or problem related to displaying content on the end user device. To resolve it, check network connectivity and refresh the content, clear the cache, update the app or software, ensure device compatibility, and verify if the latest Terms of Service has been accepted. If the issue persists, contact Support for further assistance.',
    Permanent: true,
  },
  EC_LIMITED_FUNCTIONALITY: {
    Description:
      'Denotes limited functionality or restricted access to certain features or services on the Meta side. To resolve this error, review the functionality restriction on the Meta side.',
    Permanent: true,
  },
  EC_MEDIA_UNSUPPORTED: {
    Description:
      "Indicates that the media file or format is not supported by Meta. Resolution steps involve verifying the supported media formats, converting the media file to a supported format if necessary, and ensuring compatibility with Meta's media requirements.",
    Permanent: true,
  },
  EC_DATA_MISMATCH: {
    Description:
      'Signifies a mismatch or inconsistency in the data, either locally or remotely. To resolve this error, validate its accuracy and consistency, and address any mismatches or inconsistencies. If you need additional assistance, contact Support.',
    Permanent: true,
  },
  EC_NOT_ALLOWED_SENDING_TIME: {
    Description:
      'Denotes an error where the sending time for the message is not allowed or falls outside the permitted time window. Resolution steps involve reviewing the sending time restrictions or policies, adjusting the sending time if necessary, and ensuring compliance with the permitted time frames.',
    Permanent: false,
  },
  EC_UNSUPPORTED_MOBILE_APP_VERSION: {
    Description:
      'Indicates that the mobile app version being used is not supported by Meta. To resolve this error, update the mobile app to a supported version, ensure compatibility with Meta requirements, and address any version-related issues. Contact Support for further assistance.',
    Permanent: true,
  },
  EC_MESSAGE_TYPE_EXHAUSTED: {
    Description:
      "Denotes that the message type or category has been exhausted or reached the supplier's API limit. Resolution steps involve reviewing the message type limitations and managing message usage within the allocated limits.",
    Permanent: true,
  },
  EC_BLOCKED_CONTENT: {
    Description:
      'Signifies that the content of the message is blocked or restricted due to policy violations or content filtering. To resolve this error, review the message content, ensure compliance with content guidelines, modify the content if necessary, and address any policy violations.',
    Permanent: true,
  },
  EC_USER_IDENTITY_CHANGED: {
    Description:
      "Indicates that the user's identity or authentication details have changed or become invalid. Resolution steps involve verifying the user's identity, updating authentication information if necessary, and ensuring proper user identification and authentication.",
    Permanent: true,
  },
  EC_TEMPLATE_BLOCKED_BY_USER: {
    Description: 'The receiving user has blocked a specific template.',
    Permanent: true,
  },
  EC_INVALID_WA_FLOW: {
    Description:
      'Indicates an invalid state of the flow or an incorrect mode in the Flow message. Resolution steps involve verifying the message request and flow. Applies to cases where the flow is in a deprecated, blocked, or throttled state, as well as cases of an invalid flow mode in message requests (for example, using a draft when the flow is published).',
    Permanent: true,
  },
  EC_FREQUENCY_CAPPING: {
    Description:
      'Indicates that the message was rejected because Meta limits how many WhatsApp marketing template messages a person can receive from all businesses within a certain time period. Once a user reaches this per-user limit, additional marketing templates that would start a new conversation may be blocked, starting with messages that are less likely to be read. For more details, refer to the Meta documentation.',
    Permanent: true,
  },
  EC_MARKETING_OPT_OUT: {
    Description:
      'Indicates that the message was not delivered because the recipient has opted out of receiving WhatsApp marketing messages from this business. This occurs when the end user disables the Offers and announcements setting in WhatsApp. To resume receiving marketing messages, the user must manually re-enable this option in WhatsApp. For more information, refer to the Meta documentation.',
    Permanent: true,
  },
  EC_SENDER_NOT_REGISTERED: {
    Description: 'Sender not registered on the WhatsApp Business Platform.',
    Permanent: true,
  },
  EC_CALL_PERMISSION_REQUEST_FAILED: {
    Description:
      'The maximum number of call permission requests has been reached for this business–consumer pair.',
    Permanent: false,
  },
  EC_PHONE_MATCHING_DISABLED: {
    Description:
      'Indicates a data mismatch or inconsistency, either locally or remotely. To resolve the issue, verify the accuracy and consistency of the data, and address any discrepancies or inconsistencies. Contact Support for additional assistance.',
    Permanent: true,
  },
  EC_UNSUPPORTED_DEVICE: {
    Description:
      'Denotes an unsupported or incompatible device attempting to access the service. To resolve this error, verify the device compatibility requirements, and address any device-related issues or limitations.',
    Permanent: true,
  },
  EC_TEMPLATE_NOT_SYNCED: {
    Description:
      'The newly created template was sent through MM Lite before completing ad synchronization. Please wait up to 10 minutes for ad synchronization to complete, then try again.',
    Permanent: false,
  },
  EC_TEMPLATE_NOT_AVAILABLE: {
    Description:
      'Meta was unable to complete ad synchronization for the template you want to send, or your business may not be eligible for MM Lite.',
    Permanent: false,
  },
  EC_INVALID_WA_ACCOUNT_TYPE: {
    Description:
      'The WhatsApp Business Account (WABA) uses the On-Behalf-Of (OBO) model. OBO WABAs are **not** supported. Use a different WABA or transfer ownership of the WABA to the business customer.',
    Permanent: true,
  },
  EC_PROVIDER_INTERNAL_ERROR: {
    Description:
      "Indicates an internal error or issue within the provider's system or infrastructure that is affecting the processing of messages. If you encounter this error, it is recommended to wait for some time. If the issue persists, reach out to Support for assistance and investigation.",
    Permanent: false,
  },
  EC_PROVIDER_TIMEOUT: {
    Description:
      'Signifies a timeout or connection issue with the provider and the platform. To resolve this error, contact Support for assistance in resolving the issue and investigating the underlying cause.',
    Permanent: false,
  },
  EC_PROVIDER_DR_ERROR: {
    Description:
      "Denotes an error or problem related to the provider's delivery report mechanisms or processes. Resolution steps involve contacting Support for further assistance.",
    Permanent: true,
  },
  EC_INTERNAL_ERROR: {
    Description:
      'Indicates an internal error or issue within the system or service. To resolve this error, contact Support for further assistance.',
    Permanent: true,
  },
  EC_CONFIGURATION_ERROR: {
    Description:
      "Signifies an error or problem related to the configuration settings of the sender or the sender is not registered for the targeted country on the provider's side. Resolution steps involve reviewing the configuration settings related to the sender or contacting Support for further assistance.",
    Permanent: true,
  },
  EC_TEMPORARY_GATEWAY_ERROR: {
    Description:
      'Denotes a temporary error or issue in processing messages or the communication channel. To resolve this error, contact Support for further assistance.',
    Permanent: true,
  },
  EC_SERVICE_NOT_ACTIVATED: {
    Description:
      'Indicates that the requested service or feature is not activated or enabled for the user or account. Resolution steps involve checking the service activation status and contacting Support for further assistance.',
    Permanent: true,
  },
  EC_MISSING_SENDER_METADATA: {
    Description:
      'Denotes missing or incomplete sender metadata in the request. To resolve this error, review and make sure that all required sender metadata is provided with accurate and complete sender information and contact Support for further assistance.',
    Permanent: true,
  },
  EC_DUPLICATE_REQUEST: {
    Description:
      'Signifies a duplicate or redundant request sent to the user. Resolution steps involve identifying the duplicate request, removing or deduplicating the redundant requests, and ensuring a single valid request is processed.',
    Permanent: true,
  },
  EC_BAD_ORIGIN: {
    Description:
      'Indicates an invalid or unauthorized origin or source of the request. To resolve this error, validate the request origin and contact Support for further assistance.',
    Permanent: true,
  },
};

export default DIRECT_SND_ERROR_CODES;
